import { formatLocalizedDate } from "@utils/dateUtils";
import i18n from "../i18n";

export function TimestampConverter(timestamp, notTimeDiff) {
  if (!timestamp) {
    return "-";
  }

  const date = new Date(timestamp);
  if (isNaN(date.getTime())) {
    return "-";
  }

  const now = new Date();
  const timeDifference = now - date;
  const minutesDifference = Math.floor(timeDifference / (1000 * 60));
  const hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60));

  if (minutesDifference < 60 && !notTimeDiff) {
    return i18n.t("date.minutes", "{{count}} min", { count: minutesDifference });
  } else if (hoursDifference < 24 && !notTimeDiff) {
    return i18n.t("date.hours", "{{count}} h", { count: hoursDifference });
  }

  return formatLocalizedDate(date, { day: "numeric", month: "long", year: "numeric" });
}
